

import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ 'startsAt', 'date', 'time']

  syncDatetime(event) {
    // this is needed because sometimes this event run before the mask event.
    const dateValue = $(this.dateTarget).masked(this.dateTarget.value);

    this.startsAtTarget.value = dateValue + ' ' + this.timeTarget.value;
  }
}
